import TableContainer from "@mui/material/TableContainer";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { BandBooking } from "../../__generated__/graphql";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import BandsTable from "./table";
import { useIsSuperAdmin } from "../../App";
interface IBandTableProps {
  bands: BandBooking[];
  eventTimezone: string;
  onRemoveBooking?: (bookingId: string, bandName: string) => void;
  removingBookingIds?: Set<string>;
}

const BandsTables = ({
  bands,
  eventTimezone,
  onRemoveBooking,
  removingBookingIds,
}: IBandTableProps) => {
  const [bandsPerStage, setBandsPerStage] = useState<
    Map<string, BandBooking[]>
  >(new Map<string, BandBooking[]>());
  useEffect(() => {
    if (!bands) return;

    const perStage: Map<string, BandBooking[]> = bands.reduce((prev, next) => {
      const key = next?.stage?.name ?? "No Stage";
      const bands = prev.get(key) ?? [];

      prev.set(key, [...bands, next]);

      return prev;
    }, new Map());
    setBandsPerStage(perStage);
  }, [bands]);

  const keys = Array.from(bandsPerStage?.keys());
  const [getImageSize, setGetImageSize] = useState(false);
  const isSuperAdmin = useIsSuperAdmin();

  return (
    <>
      {isSuperAdmin && (
        <FormControlLabel
          style={{ margin: 8 }}
          control={
            <Checkbox
              value={getImageSize}
              onClick={() => setGetImageSize(!getImageSize)}
            />
          }
          label={"Show image sizes"}
        />
      )}
      {keys.map((key) => {
        const bands = bandsPerStage.get(key);
        if (!bands) return null;
        return (
          <BandsTable
            bands={bands}
            eventTimezone={eventTimezone}
            getImageSize={getImageSize}
            onRemoveBooking={onRemoveBooking}
            removingBookingIds={removingBookingIds}
          />
        );
      })}
    </>
  );
};

export default BandsTables;
